import React, { useState } from "react";
import Styles from "../styles/sorting/Header.module.css";

function DesHeaderComponent(props: any) {
  const [tab1, setTab1] = useState(true);
  const [tab2, setTab2] = useState(false);

  const activateTab1 = () => {
    setTab1(true);
    setTab2(false);
    props.setTab1Visible(true);
  };

  const activateTab2 = () => {
    setTab2(true);
    setTab1(false);
    props.setTab1Visible(false);
  };

  return (
    <div className={Styles.container}>
      <div
        className={Styles.tab}
        onClick={() => activateTab1()}
        style={{
          borderBottomWidth: tab1 ? 3 : 0,
          borderBottomColor: tab1 ? "#6e6dfe" : "#22222d",
        }}
      >
        <p className={Styles.heading}>DESCRIPTION</p>
      </div>
      <div
        className={Styles.tab}
        onClick={() => activateTab2()}
        style={{
          borderBottomWidth: tab2 ? 3 : 0,
          borderBottomColor: tab2 ? "#6e6dfe" : "#22222d",
        }}
      >
        <p className={Styles.heading}>CODE</p>
      </div>
    </div>
  );
}

export default DesHeaderComponent;
